import _ from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';
import autobind from 'autobind-decorator';
import { observer, inject } from 'mobx-react';
import config from 'client/shared/config';

import AccountCreationForm from './account-creation-form';
import FIELD_KEY_MAP from './field-key-map';

const DFLT_MODAL_LABEL = 'Artist Sign Up';

@inject('artistStore', 'userStore', 'songsStore', 'formStore')
@observer
class AddBandModal extends React.Component {
	state = {
		bio: '',
		savingMessage: '',
		modalOpen: false,
		formIsValid: false,
		accountWasCreated: false,
	}

	constructor (props) {
		super(props);

		const { userStore } = this.props;

		this.props.formStore.validation = {
			profileImage: false,
			auditionBioForm: false,
			accountCreationForm: false
		};

		this.user = userStore.newUser({
			hfmPicksOptIn: true,
			role: userStore.roles.ARTIST
		});

		this.artist = this.props.artistStore.newArtist({
			scoreMatrix: []
		}, this.user);
	}

	componentDidMount () {
		document.addEventListener('keypress', this.onKeyPress);
	}

	componentWillUnmount () {
		document.removeEventListener('keypress', this.onKeyPress);
	}

	render () {
		const {
			modalContentLabel = DFLT_MODAL_LABEL
		} = this.props;
		return (

			<div className="grid-x grid-padding-x" style={{ 
					height: '100vh',
					// position: 'absolute',
					// top: '10vh',
					// bottom: '10vh',
					// left: '20vw',
					// marginLeft: 'auto',
					// marginRight: 'auto',
					// textAlign: 'center'
			}}>
				
				<div className="grid-x align-middle" style={{justifyContent:"center", backgroundColor:'transparent', width: '100%', flexDirection:'column'}}>
					<div className="logo"></div>
					<div className="admin-title">{ modalContentLabel }</div>
				</div>

				<div className="align-spaced row artist-cms main-sign-up artist-sign-up cell small-12 padding-bottom-0" style={{ backgroundColor:'transparent', color: '#fff' }}>
					{ this.renderModalContent() }
				</div>
			</div>
		);
	}

	renderModalContent () {
		if (this.props.artistStore.isLoading) {

			return (
				<div
					className="loading-spinner large text-center"
					style={{
						height: '65vh'
					}}
				>
					{ this.state.savingMessage }
				</div>
			);
		}

		if(!this.props.artistStore.isLoading && this.state.accountWasCreated) {
			return (
				<div
					className="large text-center"
					style={{
						height: '65vh'
					}}
				>
					<h2>You're Almost Live</h2>
					<p>We’ve sent a confirmation link to your inbox—just one click and your Muzado artist account goes live.</p>
				</div>
			);
		}

		return (
			<div>
				<AccountCreationForm
				 	user={ this.user }
					artist={ this.artist }
				/>

				{ this.renderButtons() }
			</div>
		);
	}

	renderButtons () {
		return (
			<div className="grid-x grid-padding-x">
				<div className="cell row align-center small-12 padding-top-2">
					<button
						data-ta="saveAddBandModalBtn"
						className="button neo mdl"
						onClick={ this.onSubmitClick }
						disabled={ this.submitDisabled() }
					>
						Sign Up
					</button>
				</div>
			</div>
		);
	}

	@autobind
	handleImageCrop (cropResult) {
		const { formStore } = this.props;

		formStore.validation = {
			profileImage: true
		};

		this.user.profileImageData = cropResult;
	}

	@autobind
	handleOpenModal () {
		this.setState({
			modalOpen: true
		});
	}

	@autobind
	handleCloseModal () {
		this.setState({
			modalOpen: false
		});
	}

	submitDisabled () {
		const {
			formStore: {
				validation: {
					accountCreationForm = false
				}
			}
		} = this.props;

		const submitDisabled =
			accountCreationForm !== true;

		console.log('[submitDisabled accountCreationForm]', accountCreationForm)

		return submitDisabled;
	}

	@autobind
	onKeyPress ({ key }) {
		const isEnterKey = (/enter/i).test(key);
		if (isEnterKey && this.submitDisabled() !== true) {

			this.onSubmitClick();
		}
	}

	@autobind
	async onSubmitClick () {
		const doesEmailExist = await this.doesEmailExist();
		if (doesEmailExist) {

			return;
		}

		const isFormValid = this.isFormValid();
		if (isFormValid !== true) {

			return;
		}

		const doPasswordsMatch = this.doPasswordsMatch();
		if (doPasswordsMatch) {

			return;
		}

		await this.saveProfile();

		if (this.props.disableAutoLogin) {

			this.pullDataAndCloseModal();
			return;
		}

		this.setState({
			accountWasCreated: true
		});

		//Delay the login redirect for 
		setTimeout(() => {
			this.handleAutoLogin();
		}, 8000);
	}

	async doesEmailExist () {
		const { user: { email }, props: { userStore } } = this;
		const { exists } = await userStore.checkEmail(email);

		if (exists) {

			toast.error(`${email} already exists.`);
			return exists;
		}
	}

	isFormValid (fields = _.values(FIELD_KEY_MAP)) {
		const { user, artist } = this;
		const { formStore } = this.props;

		const isFormValid = formStore.validateFields(fields, (key) => {
			const item = (/^user/).test(key) ? user : artist;
			const value = item[key.replace(/^.+\./, '')];

			if (key === FIELD_KEY_MAP.confirmPassword) {

				return {
					confirmPassword: value,
					password: user.password
				};
			}

			return value;
		});

		if (isFormValid !== true) {

			const message = 'Please enter all required fields';

			toast.error(message);
		}

		return isFormValid;
	}

	doPasswordsMatch () {
		const { user } = this;
		const doPasswordsMatch = user.password !== user.confirmPassword;

		if (doPasswordsMatch !== true) {

			// toast.error('Please make sure your confimation password matches your password.');
		}

		return doPasswordsMatch;
	}

	async saveProfile () {
		const { user, artist } = this;

		this.setState({
			savingMessage: 'Saving profile...'
		});

		//This is a hack, need to find out why this.user has its state cleared after save 
		this.userData = user.serialized;

		await this.props.artistStore.createArtist({ user, artist });
	}

	pullDataAndCloseModal () {
		const { artistStore, userStore } = this.props;

		artistStore.fetch();
		userStore.fetch();
		this.handleCloseModal();
	}

	handleAutoLogin () {
		window.location.href = '/login';
		// this.setState({
		// 	savingMessage: 'Log in...'
		// });

		// this.props.userStore.checkLogin(this.userData, {
		// 	sendRedirect: true
		// });
	}
};	


export default AddBandModal;
